module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elImage_140921196.f1a850b1.png";